import React from 'react';
import { Spinner, Text } from '@spark';

/**
 * Manual "Infer from response" affordance for JSON schema fields.
 * Used next to the JSON schema help icon on the teacher row and student override.
 */
const InferFromResponseAction = ({
    onInferFromResponse = null,
    inferDisabled = false,
    loading = false,
}) => {
    if (loading) {
        return (
            <span
                className="fs-unmask model-setup-infer-from-response"
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    color: 'var(--semantic-content-secondary, #666)',
                    whiteSpace: 'nowrap',
                }}
            >
                <Spinner size="small" />
                <Text variant="detail-regular" as="span">
                    Updating schema…
                </Text>
            </span>
        );
    }

    if (typeof onInferFromResponse !== 'function') {
        return null;
    }

    return (
        <span
            className="fs-unmask model-setup-infer-from-response"
            role="button"
            tabIndex={0}
            aria-disabled={inferDisabled}
            style={{
                color: inferDisabled
                    ? 'var(--semantic-content-disabled, #999)'
                    : 'var(--semantic-button-ghost-content-on-surface-default)',
                cursor: inferDisabled ? 'not-allowed' : 'pointer',
                userSelect: 'none',
                whiteSpace: 'nowrap',
            }}
            onClick={() => !inferDisabled && onInferFromResponse()}
            onKeyDown={(e) => {
                if ((e.key === 'Enter' || e.key === ' ') && !inferDisabled) {
                    e.preventDefault();
                    onInferFromResponse();
                }
            }}
        >
            Infer from response
        </span>
    );
};

export default InferFromResponseAction;
